import { BackendClient, GraphQLClient, PublicApiClient, requestIdHeader } from '@tf/api';
import { useGetAuthToken } from '@tf/shared';
import { Box, Modal, ModalFooter, TFText } from '@tf/ui';
import type React from 'react';
import { useEffect, useState } from 'react';

import { useConfig } from './ConfigProvider';
import { useDefinitions } from './DefinitionsProvider';

export const EndClientAreaBackendClientInitialization: React.FC = () => {
	const config = useConfig();
	const { revision, reloadDefinitions } = useDefinitions();

	const getToken = useGetAuthToken();

	const [isModalOpened, setModalOpened] = useState(false);

	useEffect(() => {
		const fetchWithStatusCheck = async (input: RequestInfo | URL, init?: RequestInit) => {
			const token = await getToken();
			const response = await fetch(input, {
				...init,
				headers: {
					...init?.headers,
					...requestIdHeader(),
					Authorization: `Bearer ${token}`,
					'Configuration-Revision': revision,
				},
			});

			if (response.status === 409) {
				setModalOpened(true);
			}

			return response;
		};

		BackendClient.init(config.urls.backend, fetchWithStatusCheck);
		PublicApiClient.init(config.urls.api, fetchWithStatusCheck);
		GraphQLClient.init(`${config.urls.api}/graphql`, getToken);
	}, [config.urls.backend, config.urls.api, revision, getToken]);

	const onReload = async () => {
		await reloadDefinitions();
		setModalOpened(false);
	};

	return (
		<Modal title="App is oudated" opened={isModalOpened} withCloseButton={false} onClose={() => {}}>
			<Box px="1rem" py="0.75rem">
				<TFText>Please reload page to get new version</TFText>
			</Box>

			<ModalFooter submitLabel="Reload" onSubmit={onReload} />
		</Modal>
	);
};
